import __request__ from "routing/request";
export function buildBundle(requestOptions) {
  return __request__("POST", "/cluster/debug/support/bundle/build", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function download(filename, requestOptions) {
  return __request__("GET", `/cluster/debug/support/bundle/download/${filename}`, null, {}, {
    "Accept": ["application/octet-stream"]
  }, requestOptions);
}
export function listBundles(requestOptions) {
  return __request__("GET", "/cluster/debug/support/bundle/list", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function remove(filename, requestOptions) {
  return __request__("DELETE", `/cluster/debug/support/bundle/${filename}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getClusterManifest(requestOptions) {
  return __request__("GET", "/cluster/debug/support/manifest", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
